import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import Screen from '../../components/fragments/Screen';
import AnnouncementScreen from './AnnouncementScreen';
import ReminderScreen from './ReminderScreen';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </div>
    );
}

export default function NotificationScreen() {
    const [value, setValue] = useState(0);

    const theme = useTheme();
    const state = useSelector((st) => st);

    const { announcements, reminders, busy } = state.list2;
    const badgeValueMinus = announcements?.length + reminders?.length;

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    useEffect(() => {
        localStorage.setItem('knsappntf', badgeValueMinus);
    }, [badgeValueMinus]);

    return (
        <Screen
            loading={busy['announcements'] || busy['reminders']}
            disablePadding
            disableSpacing
            title="Notifications"
        >
            <AppBar
                sx={{ mt: 1 }}
                style={{
                    position: 'relative',
                    top: -8,
                    backgroundColor: theme.palette.background.paper,
                    width: '100%',
                    zIndex: 1,
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="fullWidth"
                    textColor={
                        theme.palette.mode == 'light' ? 'primary' : 'inherit'
                    }
                >
                    <Tab label="Announcements" />
                    <Tab label="Reminders" />
                </Tabs>
            </AppBar>
            <Grid
                item
                xs={12}
                style={{ width: '100%', position: 'relative', top: -4 }}
            >
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <AnnouncementScreen />
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <ReminderScreen />
                    </TabPanel>
                </SwipeableViews>
            </Grid>
        </Screen>
    );
}
